import { useEffect, useState } from "react";
import PropTypes from "prop-types";

import { Tooltip } from "components/Tooltip";
import { Title } from "style/components/Title.styles";
import { calcPercentage, getRiskPotentialLabel, roundOff } from "utils";

const RiskPotential = ({ data }) => {
  const [percent, setPercentage] = useState(0);
  const [value, setValue] = useState(0);

  useEffect(() => {
    if (!data?.length) return;

    const { value } = data.find((d) => d.name === "Risk Score");
    const val = Number(value);

    setPercentage(calcPercentage(val, 5));
    setValue(roundOff(val));
  }, [data]);

  return (
    <div className="secondary aggression-level p-0">
      <Title className="title mb-4">Risk potential</Title>

      <div className="d-flex align-items-center">
        <Title className="mb-2 sub-title">{getRiskPotentialLabel(value)}</Title>{" "}
      </div>

      <div className="description">
        See how this strategy’s risk potential stacks up against other
        strategies
      </div>

      <div className="line-wrapper">
        <div className={"line"} />
      </div>

      <div className="label-wrapper">
        <div className="arrow" style={{ marginLeft: `${percent}%` }}>
          <Tooltip value={value}>
            <div className="arrow-up" />
          </Tooltip>
        </div>
      </div>

      <div className="label-wrapper">
        <div className="label">Lower</div>
        <div className="label">Moderate</div>
        <div className="label">Higher</div>
      </div>
    </div>
  );
};

export default RiskPotential;

RiskPotential.propTypes = {
  data: PropTypes.array,
};
